<template>
  <b-tab :lazy="lazy">
    <template slot="title">
      <span ref="text__tab-name" class="font-size-md active text__tab-name">{{ title }}</span>

      <div class="divider"></div>
    </template>

    <b-row align-v="start">
      <b-col cols="8">
        <h5 ref="text__tab-title" class="font-weight-bold text__tab-title">
          {{ title }}
        </h5>

        <p ref="text__tab-sub-title" class="text-dark text__tab-sub-title">
          {{ subTitle }}
        </p>
      </b-col>

      <b-col cols="4" class="text-right">
        <slot name="main-action"></slot>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <slot></slot>
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Title'
    },

    subTitle: {
      type: String,
      default: 'Sub Title'
    },

    lazy: {
      type: Boolean,
      default: true
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    }
  }
};
</script>
